export class PrestacionReferencia {
  private descripcionPrestacion: string;
  private descripcionDeterminacion: string;
  private valoresReferencia: string;
  private material: string;

  constructor(
    descripcionPrestacion: string = "N/A", // Valor predeterminado "N/A"
    descripcionDeterminacion: string = "N/A",
    valoresReferencia: string = "N/A",
    material: string = "N/A"
  ) {
    this.descripcionPrestacion = descripcionPrestacion;
    this.descripcionDeterminacion = descripcionDeterminacion;
    this.valoresReferencia = valoresReferencia;
    this.material = material;
  }

  // Métodos getter y setter
  public getDescripcionPrestacion(): string {
    return this.descripcionPrestacion;
  }

  public setDescripcionPrestacion(descripcionPrestacion: string): void {
    this.descripcionPrestacion = descripcionPrestacion || "N/A"; // Verificar si está indefinido
  }

  public getDescripcionDeterminacion(): string {
    return this.descripcionDeterminacion;
  }

  public setDescripcionDeterminacion(descripcionDeterminacion: string): void {
    this.descripcionDeterminacion = descripcionDeterminacion || "N/A";
  }

  public getValoresReferencia(): string {
    return this.valoresReferencia;
  }

  public setValoresReferencia(valoresReferencia: string): void {
    this.valoresReferencia = valoresReferencia || "N/A";
  }

  public getMaterial(): string {
    return this.material;
  }

  public setMaterial(material: string): void {
    this.material = material || "N/A";
  }

  // Método toString para mostrar los datos de la clase
  public toString(): string {
    return `PrestacionReferencia: {
        descripcionPrestacion: ${this.descripcionPrestacion},
        descripcionDeterminacion: ${this.descripcionDeterminacion},
        valoresReferencia: ${this.valoresReferencia},
        material: ${this.material}
      }`;
  }

  // Método estático para mapear una colección de objetos de la API a PrestacionReferencia
  public static fromCollection(apiData: any[]): PrestacionReferencia[] {
    return apiData.map(
      (item) =>
        new PrestacionReferencia(
          item.descripcion_prestacion || "N/A",
          item.descripcion_determinacion || "N/A",
          item.valores_referencia || "N/A",
          item.material || "N/A"
        )
    );
  }
}
